import {
  Ref,
  unref,
} from 'vue';

export type MaybeRef<T> = T | Ref<T>
export type RefsMap = Record<string, MaybeRef<any>>

export function commonObjectUnref(object: RefsMap) {
  return Object.fromEntries(Object.entries(object).map(([key, value]) => [key, unref(value)]));
}
